import { LOCAL_STORAGE } from '~/constants';

const getKey = (type: string, attr: any): string => {
    const splitStr = '.';
    let key = '';
    switch (type) {
        case LOCAL_STORAGE.CONTACT_LAYOUT_WIDTH:
            key = [type, attr.memberId].join(splitStr);
            break;
    }
    return key;
};

export { getKey };
